import type { Template } from "@/types";

export const PO_07_H3_V4: Template[] = [
    {
        id: "po-07-h3v4-01",
        name: "PO 01 - H3V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h3_v4_01.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 48, y: 158, width: 591, height: 389, rotation: 0, imageRotation: 0 },
            { id: "2", x: 48, y: 555, width: 292, height: 203, rotation: 0, imageRotation: 0 },
            { id: "3", x: 348, y: 555, width: 291, height: 203, rotation: 0, imageRotation: 0 },
            { id: "4", x: 812, y: 158, width: 215, height: 296, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1035, y: 158, width: 214, height: 296, rotation: 0, imageRotation: 0 },
            { id: "6", x: 812, y: 462, width: 215, height: 296, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1035, y: 462, width: 214, height: 296, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h3v4-02",
        name: "PO 02 - H3V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h3_v4_02.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 68, y: 186, width: 222, height: 177, rotation: 0, imageRotation: 0 },
            { id: "2", x: 68, y: 371, width: 222, height: 176, rotation: 0, imageRotation: 0 },
            { id: "3", x: 68, y: 555, width: 222, height: 176, rotation: 0, imageRotation: 0 },
            { id: "4", x: 298, y: 186, width: 337, height: 545, rotation: 0, imageRotation: 0 },
            { id: "5", x: 741, y: 186, width: 375, height: 545, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1124, y: 186, width: 184, height: 269, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1124, y: 463, width: 184, height: 268, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h3v4-03",
        name: "PO 03 - H3V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h3_v4_03.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 39, y: 145, width: 617, height: 406, rotation: 0, imageRotation: 0 },
            { id: "2", x: 39, y: 559, width: 305, height: 212, rotation: 0, imageRotation: 0 },
            { id: "3", x: 352, y: 559, width: 304, height: 212, rotation: 0, imageRotation: 0 },
            { id: "4", x: 717, y: 145, width: 461, height: 626, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1186, y: 145, width: 148, height: 204, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1186, y: 357, width: 148, height: 203, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1186, y: 568, width: 148, height: 203, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-07-h3v4-04",
        name: "PO 04 - H3V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h3_v4_04.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 161, y: 87, width: 364, height: 245, rotation: 0, imageRotation: 0 },
            { id: "2", x: 161, y: 340, width: 364, height: 245, rotation: 0, imageRotation: 0 },
            { id: "3", x: 161, y: 593, width: 364, height: 245, rotation: 0, imageRotation: 0 },
            { id: "4", x: 770, y: 87, width: 257, height: 372, rotation: 0, imageRotation: 0 },
            { id: "5", x: 770, y: 467, width: 257, height: 371, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1035, y: 87, width: 257, height: 372, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1035, y: 467, width: 257, height: 371, rotation: 0, imageRotation: 0 }
        ],
    },
   
    {
        id: "po-07-h3v4-05",
        name: "PO 05 - H3V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h3_v4_05.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 63, y: 165, width: 560, height: 388, rotation: 0, imageRotation: 0 },
            { id: "2", x: 63, y: 560, width: 277, height: 191, rotation: 0, imageRotation: 0 },
            { id: "3", x: 348, y: 560, width: 276, height: 191, rotation: 0, imageRotation: 0 },
            { id: "4", x: 829, y: 165, width: 198, height: 290, rotation: 0, imageRotation: 0 },
            { id: "5", x: 829, y: 463, width: 198, height: 289, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1035, y: 165, width: 197, height: 290, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1035, y: 463, width: 197, height: 289, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h3v4-06",
        name: "PO 06 - H3V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h3_v4_06.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 96, y: 86, width: 496, height: 332, rotation: 0, imageRotation: 0 },
            { id: "2", x: 96, y: 592, width: 160, height: 238, rotation: 0, imageRotation: 0 },
            { id: "3", x: 264, y: 592, width: 160, height: 238, rotation: 0, imageRotation: 0 },
            { id: "4", x: 432, y: 592, width: 160, height: 238, rotation: 0, imageRotation: 0 },
            { id: "5", x: 96, y: 426, width: 244, height: 158, rotation: 0, imageRotation: 0 },
            { id: "6", x: 348, y: 426, width: 244, height: 158, rotation: 0, imageRotation: 0 },
            { id: "7", x: 783, y: 86, width: 496, height: 743, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-07-h3v4-07",
        name: "PO 07 - H3V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h3_v4_07.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 96, y: 86, width: 244, height: 158, rotation: 0, imageRotation: 0 },
            { id: "2", x: 348, y: 86, width: 244, height: 158, rotation: 0, imageRotation: 0 },
            { id: "3", x: 96, y: 252, width: 496, height: 332, rotation: 0, imageRotation: 0 },
            { id: "4", x: 96, y: 592, width: 160, height: 238, rotation: 0, imageRotation: 0 },
            { id: "5", x: 264, y: 592, width: 160, height: 238, rotation: 0, imageRotation: 0 },
            { id: "6", x: 432, y: 592, width: 160, height: 238, rotation: 0, imageRotation: 0 },
            { id: "7", x: 783, y: 86, width: 496, height: 743, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h3v4-08",
        name: "PO 08 - H3V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h3_v4_08.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 0, y: 216, width: 683, height: 483, rotation: 0, imageRotation: 0 },
            { id: "2", x: 691, y: 216, width: 338, height: 230, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1037, y: 216, width: 337, height: 230, rotation: 0, imageRotation: 0 },
            { id: "4", x: 691, y: 454, width: 165, height: 245, rotation: 0, imageRotation: 0 },
            { id: "5", x: 864, y: 454, width: 165, height: 245, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1037, y: 454, width: 165, height: 245, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1210, y: 454, width: 164, height: 245, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h3v4-09",
        name: "PO 09 - H3V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h3_v4_09.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 0, y: 235, width: 288, height: 446, rotation: 0, imageRotation: 0 },
            { id: "2", x: 296, y: 235, width: 190, height: 144, rotation: 0, imageRotation: 0 },
            { id: "3", x: 296, y: 387, width: 190, height: 143, rotation: 0, imageRotation: 0 },
            { id: "4", x: 296, y: 538, width: 190, height: 143, rotation: 0, imageRotation: 0 },
            { id: "5", x: 494, y: 235, width: 288, height: 446, rotation: 0, imageRotation: 0 },
            { id: "6", x: 790, y: 235, width: 288, height: 446, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1086, y: 235, width: 288, height: 446, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h3v4-10",
        name: "PO 10 - H3V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h3_v4_10.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 0, y: 235, width: 288, height: 446, rotation: 0, imageRotation: 0 },
            { id: "2", x: 296, y: 235, width: 288, height: 446, rotation: 0, imageRotation: 0 },
            { id: "3", x: 592, y: 235, width: 288, height: 446, rotation: 0, imageRotation: 0 },
            { id: "4", x: 888, y: 235, width: 288, height: 446, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1184, y: 235, width: 190, height: 144, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1184, y: 387, width: 190, height: 143, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1184, y: 538, width: 190, height: 143, rotation: 0, imageRotation: 0 }
        ],
    },
];
